export default "__VITE_ASSET__DeQ9_Dt9__"